"use client";

import { usePathname } from "next/navigation";
import { Pagination } from "antd";
import Link from "next/link";
import "./index.scss";

const PaginationSection = ({ data }) => {
  const pathName = usePathname();
  return (
    <div className="wp-pagination">
      <Pagination
        current={parseInt(data.current)}
        total={data.total}
        pageSize={13}
        showSizeChanger={false}
        itemRender={(page, type, defaultItem) => {
          if (type == "page")
            return <Link href={`${pathName}?page=${page}`}>{page}</Link>;
          return defaultItem;
        }}
      />
    </div>
  );
};

export default PaginationSection;
